import { login, logout, getUserInfo } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const getDefaultState = () => ({
  token: getToken(),
  userId: 0,
  userName: '',
  realName: '',
  avatar: '',
  roles: [],
  permissions: []
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    RESET_STATE: state => Object.assign(state, getDefaultState()),
    SET_TOKEN: (state, token) => { state.token = token },
    SET_USER: (state, info) => {
      state.userId = info.userId
      state.userName = info.userName
      state.realName = info.realName
      state.avatar = info.avatar
      state.roles = info.roles || []
      state.permissions = info.permissions || []
    }
  },
  actions: {
    login({ commit }, userInfo) {
      const { userName, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userName: userName.trim(), password }).then(res => {
          const data = res.data
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          resolve(data)
        }).catch(reject)
      })
    },
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SET_USER', res.data)
          resolve(res.data)
        }).catch(reject)
      })
    },
    logout({ commit }) {
      return new Promise(resolve => {
        logout().finally(() => {
          removeToken()
          commit('RESET_STATE')
          resolve()
        })
      })
    },
    resetToken({ commit }) {
      return new Promise(resolve => {
        removeToken()
        commit('RESET_STATE')
        resolve()
      })
    }
  }
}
